import tipoFormularioService from '../services/tipoFormularioService';

/** Convención maestro: 0 = Sí descuenta/reserva; 1 = No. */
const DESCUENTA_SI = 0;
const DESCUENTA_NO = 1;

const TIPO_REMITO = '9';
const TIPO_FACTURA = '1';

export type PoliticaStockResult = {
  remitoDescuenta: boolean;
};

let cachedOk: PoliticaStockResult | null = null;
let cachedFacturaDescuenta: boolean | null = null;

export function interpretaDescuentaStock(descuentaStock: number | null | undefined): boolean {
  return descuentaStock == null || Number(descuentaStock) === DESCUENTA_SI;
}

async function leerDescuenta(nroTipo: string): Promise<boolean | null> {
  try {
    const tipo = await tipoFormularioService.getTipoFormulario(nroTipo);
    return interpretaDescuentaStock(tipo.descuentaStock);
  } catch {
    return null;
  }
}

async function forzarDescuenta(nroTipo: string, debeDescontar: boolean): Promise<void> {
  try {
    const tipo = await tipoFormularioService.getTipoFormulario(nroTipo);
    const actual = interpretaDescuentaStock(tipo.descuentaStock);
    if (actual === debeDescontar) return;
    await tipoFormularioService.updateTipoFormulario(nroTipo, {
      ...tipo,
      descuentaStock: debeDescontar ? DESCUENTA_SI : DESCUENTA_NO,
    });
  } catch {
    /* sin permiso / tipo inexistente */
  }
}

/**
 * Indica si la factura de venta (tipo 1) descuenta stock real.
 * Si no se puede leer el maestro, asume que sí (para no omitir lotes por error de red).
 */
export async function facturaVentaDescuentaStock(options?: {
  force?: boolean;
}): Promise<boolean> {
  if (!options?.force && cachedFacturaDescuenta != null) {
    return cachedFacturaDescuenta;
  }
  const lectura = await leerDescuenta(TIPO_FACTURA);
  const result = lectura !== false;
  if (lectura != null) cachedFacturaDescuenta = result;
  return result;
}

/**
 * Asegura que el remito de venta (tipo 9) tenga DescuentaStock activo.
 * Pedido (12) reserva; factura (1) descuenta: flags configurados en TipoFormulario, no se alteran aquí.
 */
export async function asegurarStockSoloEnRemito(options?: {
  force?: boolean;
}): Promise<PoliticaStockResult> {
  if (cachedOk && !options?.force && cachedOk.remitoDescuenta) {
    return cachedOk;
  }

  await forzarDescuenta(TIPO_REMITO, true);

  const lecturaRemito = await leerDescuenta(TIPO_REMITO);
  const remitoDescuenta = lecturaRemito === true;

  const result: PoliticaStockResult = { remitoDescuenta };
  if (result.remitoDescuenta) {
    cachedOk = result;
  } else {
    cachedOk = null;
  }
  return result;
}
